import { routesTemplate } from "../routesTemplate";

import JourneyScreen from "../../screens/journeyStack/JourneyScreen";
import JourneyInProgressScreen from "../../screens/journeyStack/JourneyInProgressScreen";
import JourneyCompletedScreen from "../../screens/journeyStack/JourneyCompletedScreen";
import JourneyDetailsScreen from "../../screens/journeyStack/JourneyDetailsScreen";

import JourneyHubScreen from "../../screens/journeyStack/JourneyHubScreen";
import JourneyRatingScreen from "../../screens/journeyStack/JourneyRatingScreen";

import JourneyTimelineScreen from "../../screens/journeyStack/JourneyTimelineScreen";

import Video from "../../screens/journeyStack/knowledgeElements/video/Video";
import ExternalLink from "../../screens/journeyStack/knowledgeElements/externalLink/ExternalLink";
import PodcastScreen from "../../screens/journeyStack/knowledgeElements/podcast/PodcastScreen";
import Webinar from "../../screens/journeyStack/knowledgeElements/webinar/Webinar";
import Enigma from "../../screens/journeyStack/knowledgeElements/enigma/Enigma";
import Quiz from "../../screens/journeyStack/knowledgeElements/quiz/Quiz";
import Article from "../../screens/journeyStack/knowledgeElements/article/Article";


export const journeyStack = [
    routesTemplate('/journeys/new', JourneyScreen, "Novas Jornadas"),
    routesTemplate('/journeys/inprogress', JourneyInProgressScreen),
    routesTemplate('/journeys/completed', JourneyCompletedScreen),

    routesTemplate('/journey/details', JourneyDetailsScreen),
    routesTemplate('/journey/hub', JourneyHubScreen),
    routesTemplate('/journey/rating', JourneyRatingScreen),

    routesTemplate('/journey/timeline', JourneyTimelineScreen),

    routesTemplate('/journey/timeline/video', Video),
    routesTemplate('/journey/timeline/externallink', ExternalLink),
    routesTemplate('/journey/timeline/podcast', PodcastScreen),
    routesTemplate('/journey/timeline/webinar', Webinar),
    routesTemplate('/journey/timeline/attendance', Webinar),
    routesTemplate('/journey/timeline/enigma', Enigma),
    routesTemplate('/journey/timeline/quiz', Quiz),
    routesTemplate('/journey/timeline/article', Article),
];
